export const getNextIndex = (currentIndex, list, isBackword): number => {
    if (!list) return 0;
    if (currentIndex === list.length - 1 && !isBackword) return 0;
    if (currentIndex === 0 && isBackword) return list.length - 1;

    return isBackword ? currentIndex - 1 : currentIndex + 1;
};
